import { UpdateCertificateOfCertificationsRequest } from "../../../types/api/collaborators.type";
import httpClient from "../../client/HttpClient";

const CollaboratorsHistoryCertificateOfCertificationsService = {
  async get(
    collaboratorId: number,
    certificationId: number,
  ): Promise<ArrayBuffer> {
    const response = await httpClient.get<ArrayBuffer>(
      `v1/collaborators/${collaboratorId}/history/certifications/${certificationId}/certificate`,
      { responseType: "arraybuffer" },
    );

    return response;
  },
  async update(
    collaboratorId: number,
    certificationId: number,
    body: UpdateCertificateOfCertificationsRequest,
  ): Promise<void> {
    await httpClient.put(
      `v1/collaborators/${collaboratorId}/history/certifications/${certificationId}/certificate`,
      body,
      { contentType: "multipart/form-data" },
    );
  },
  async delete(collaboratorId: number, certificationId: number): Promise<void> {
    await httpClient.delete(
      `v1/collaborators/${collaboratorId}/history/certifications/${certificationId}/certificate`,
    );
  },
};

export default CollaboratorsHistoryCertificateOfCertificationsService;
